import { createFileRoute } from "@tanstack/react-router"
import { map } from "lodash-es"
import MarketingLayout from "~/layouts/MarketingLayout"
import { api } from "~/utils/api"
import dayjs from "dayjs"

export const Route = createFileRoute("/changelog")({
  component: Changelog,
})

function Changelog() {
  const { data: changelogEntries } = api.admin.apiGetChangelog.useQuery()

  return (
    <MarketingLayout>
      <div className="container mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl mb-12 md:mb-16">
          Changelog
        </h1>

        {map(changelogEntries, (entry, index) => (
          <div
            key={entry.guid || index}
            className="grid grid-cols-1 md:grid-cols-[10rem_1fr] gap-x-8 lg:gap-x-12 gap-y-3 mb-8 md:mb-12"
          >
            <div className="relative md:sticky md:top-24 h-fit md:text-right">
              <div className="absolute left-0 top-1 h-2 w-2 rounded-full bg-primary -ml-4 md:hidden" />
              <div className="hidden md:block absolute right-0 top-1 h-2 w-2 rounded-full bg-primary -mr-4" />
              <div className="text-sm font-medium text-muted-foreground md:pr-8">
                {entry.pubDate ? dayjs(entry.pubDate).format("MMM DD, YYYY") : "Recent"}
              </div>
            </div>

            <div className="pl-6 md:pl-0 border-l border-border md:border-l-0 md:border-r md:pr-8 pb-6 md:pb-0">
              <h2 className="text-xl font-semibold text-foreground mb-3">
                {entry.title || "Update"}
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>{entry.contentSnippet || "New features and improvements."}</p>
              </div>
            </div>
          </div>
        ))}

        {(!changelogEntries || changelogEntries.length === 0) && (
          <p className="text-center text-muted-foreground">No changelog entries available.</p>
        )}
      </div>
    </MarketingLayout>
  )
}